import { NgModule } from "@angular/core";
import { HighlightPipe } from "src/app/pipes/highlight/highlight.pipe";
import { KebabCasePipe } from "../../pipes/kebab-case.pipe";
import { SafeResourceUrlPipe } from "../../pipes/safeResourceUrl/safe-resource-url.pipe";
import { StripHtmlPipe } from "../../pipes/striphtml/strip-html.pipe";

@NgModule({
  exports: [KebabCasePipe, SafeResourceUrlPipe, HighlightPipe, StripHtmlPipe],
  imports: [KebabCasePipe, SafeResourceUrlPipe, HighlightPipe, StripHtmlPipe],
  providers: [KebabCasePipe, SafeResourceUrlPipe, HighlightPipe, StripHtmlPipe],
})
export class PipesModule {}
